import { createFileRoute, redirect } from '@tanstack/react-router';
import { FormPageTemplatePending } from '@/components/v2/page-template-pending';

// Writing a review needs a session, and the public layout deliberately no longer
// gates it. The API also rejects unauthenticated writes, so this guard exists to
// keep an anonymous visitor out of a dead-end form rather than for security.
export const Route = createFileRoute('/_public/studios/$studioId/reviews/new')({
  // Form-shaped pending while the lazy chunk downloads; title matches the page
  // the route becomes (aria-labelled, kept out of the visual tree as a block).
  pendingComponent: () => <FormPageTemplatePending title="Write your review" cta />,
  beforeLoad: ({ context, location }) => {
    if (context.authState === 'unauthenticated') {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
  },
});
